<template>
  <div class="content-tab syshttps">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="formRow https">
          <div class="formlabel">
            <div class="checkbox-wrapper" @click="onSelection('httpsEnable')">
              <checkbox class="q-checkbox-label" :checked="isItemChecked('httpsEnable')" :label="$t('systemHttps.checkboxHttpsEnable')"></checkbox>
            </div>
          </div>
          <div class="forminput" :class="{disabled: !isItemChecked('httpsEnable')}">
            <div class="table-row">
              <div class="tls">
                <div class="title">{{$t('systemHttps.tlsVersion')}}</div>
                <div class="select-wrapper">
                  <q-select class="q-select tls-type" :value="config.tlsType" :options-array="tlsOptions" @change="onTlsTypeChange"  :isDisabled="!isItemChecked('httpsEnable')"></q-select>
                  <!-- <span ref="infoTips" class="icon-info info-color ft-14 tlsVersionInfo" v-on:click="onInfoClick"></span> -->
                </div>
                <div class="info">Notice: {{$t('systemHttps.tlsVersionInfo')}}</div>
              </div>
            </div>
            <div class="table-row" hidden="true">
              <div class="httpsPort">
                <div class="title">{{$t('systemHttps.portNumber')}}</div>
                <div class="input-wrapper">
                  <input type="text" ref="port" name="port" v-model="config.httpsPort" class="form-control" @input="onBlur" :disabled="!isItemChecked('httpsEnable')" v-validate="'required|port'" :class="{'error': ((isValidateInvalid('port')))}">
                  <!-- <input type="text" ref="port" name="port" v-model="config.httpsPort" class="form-control" @keyup="onPortNumberChange" :disabled="!isItemChecked('httpsEnable')" v-validate.immediate="'required|port'" :class="{'error': ((isValidateInvalid('port')))}"> -->
                </div>
                <div v-show="(isValidateInvalid('port') && isItemChecked('httpsEnable'))" class="errorMessage">{{ getErrorMsg('port') }}</div>
              </div>
            </div>
            <div class="table-row">
              <div class="httpsOnly">
                <div class="checkbox-wrapper" @click="onSelection('httpsOnlyEnable')">
                  <checkbox class="q-checkbox-label" :class="{disabled: !isItemChecked('httpsEnable')}" :label="$t('systemHttps.checkboxHttpsOnlyEnable')" :checked="isItemChecked('httpsOnlyEnable')" :disabled="!isItemChecked('httpsEnable')"></checkbox>
                </div>
                <!-- <span ref="infoTips" class="icon-info info-color ft-14 httpsOnlyInfo" v-on:click="onInfoClick"></span> -->
                <div class="info">Notice: {{$t('systemHttps.httpsOnlyInfo')}}</div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable()">{{$t('save')}}</button>
      </div>
    </div>
    <!-- <modal class="popup_dialog alert" name="modal-alert" :class="ifTop"
       transition="nice-modal-fade"
       :width="450"
       :min-width="450"
       height="auto"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       classes='q-v--modal'>
      <div class="modal-content">
        <div class="modal-header">
          <div class="dialog-icon icon-warning"></div>
          <div class="dialog-header">{{modalTitle}}</div>
          <div class="icon-btn_close modal-close" @click="onClose"></div>
        </div>
        <div class="modal-body">
          <div class="modal-container">
            <div class="message">
              {{$t('systemDhcp.qfinderContent')}}
            </div>
            <div class="message">
              <a href="https://www.qnap.com/en/utilities/essentials" target="_blank">{{$t('systemDhcp.qfinderTitle')}}</a>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="footer-left">
          </div>
          <div class="footer-right">
            <button class="q-button blue-btn-full" @click="goSave" :title="$t('save')">{{$t('yes')}}</button>
            <button class="q-button" @click="onClose" :title="$t('cancel')">{{$t('cancel')}}</button>
          </div>
        </div>
      </div>
    </modal> -->
  </div>
</template>

<script>
import checkbox from './module/Checkbox'
import qSelect from './module/Select.vue'
import {
  // mapState, mapMutations, mapActions, mapGetters
  mapState, mapMutations, mapActions
} from 'vuex'
export default {
  name: 'syshttps',
  components: {
    checkbox,
    qSelect
  },
  data () {
    return {
      // modalname: 'modal-alert',
      original: {
        tlsType: '',
        isHttpsEnable: false,
        isHttpsOnlyEnable: false,
        httpsPort: '443'
      },
      config: null,
      tlsOptions: [
        {label: 'systemHttps.tlsVersionLabel11', value: '1.1'},
        {label: 'systemHttps.tlsVersionLabel12', value: '1.2'}
      ],
      // isModalOpen: false,
      isShowLoading: false
    }
  },
  created () {
    this.initValidator()
    this.initData()
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  mounted () {
    this.getData()
  },
  watch: {
  },
  methods: {
    initData: async function () {
      this.config = Object.assign({}, this.original)
    },
    initValidator: async function () {
      let me = this
      this.$validator.extend('port', {
        getMessage (field, val) {
          return me.$t('errorMessage.password')
        },
        validate (value, field) {
          var temp = /^[0-9]{3,5}$/
          if (!temp.test(value)) {
            return false
          }
          let port = parseInt(value)
          if (!((port >= 1025 && port <= 65535) || (port === 443))) {
            return false
          }
          return true
        }
      })
    },
    getData: async function (errorHandle) {
      this.isShowLoading = !this.showFullLoading
      let me = this
      this.getSystemHttps()
        .then(res => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            let data = res.data.result
            me.original.isHttpsEnable = data.HttpsEnable
            me.original.isHttpsOnlyEnable = data.HttpsOnly
            switch (data.TLSVersion) {
              case '1.1':
                me.original.tlsType = '1.1'
                break
              case '1.2':
                me.original.tlsType = '1.2'
                break
            }
            me.config = Object.assign({}, me.original)
            me.isShowLoading = false
          }
        })
        .catch(error => {
          this.$log.error(error)
          errorHandle()
        })
    },
    onTlsTypeChange: function (value) {
      this.config.tlsType = value
    },
    isButtonEnable: function () {
      var isEnable = false
      if (!this.$compareObj(this.original, this.config) && !this.isValidateInvalid('port')) {
        isEnable = true
      }
      this.$store.commit('updateDataChanged', isEnable)
      return isEnable
    },
    onSelection: function (type) {
      if (type === 'httpsEnable') {
        this.config.isHttpsEnable = !this.config.isHttpsEnable
        // if (this.config.isHttpsEnable === false) {
        //   this.config.isHttpsOnlyEnable = false
        // }
      } else if (type === 'httpsOnlyEnable') {
        if (this.config.isHttpsEnable === true) {
          this.config.isHttpsOnlyEnable = !this.config.isHttpsOnlyEnable
        }
      }
    },
    isItemChecked: function (type) {
      if (type === 'httpsEnable') {
        return (this.config.isHttpsEnable)
      } else if (type === 'httpsOnlyEnable') {
        return (this.config.isHttpsOnlyEnable)
      }
    },
    goSave: function () {
      if (this.isModalOpen) {
        this.onClose()
      }
      this.isShowLoading = true
      let setData = {
        HttpsEnable: this.config.isHttpsEnable,
        HttpsOnly: false,
        TLSVersion: this.original.tlsType,
        HttpsPort: '443'
      }
      if (this.config.isHttpsEnable) {
        setData.HttpsOnly = this.config.isHttpsOnlyEnable
        setData.TLSVersion = this.config.tlsType
      }
      let isReload = false
      if ((this.config.isHttpsEnable === true && this.config.isHttpsOnlyEnable === true && document.location.protocol === 'http:') ||
          (this.config.isHttpsEnable === false && document.location.protocol === 'https:')) {
        isReload = true
        this.isShowLoading = false
        this.$store.commit('updateFullLoadingStatus', true)
      }
      this.setSystemHttps(setData)
        .then(res => {
          if (res.data.error_code === 200) {
            setTimeout(() => {
              var errorHandle = function () {}
              if (isReload) {
                errorHandle = function () {
                  window.location.reload(true)
                }
              }
              this.getData(errorHandle)
            }, this.intervalTime)
          }
        })
        .catch(error => {
          this.$log.error(error)
          this.isShowLoading = false
          if (this.showFullLoading) {
            this.$store.commit('updateFullLoadingStatus', false)
          }
        })
    },
    onSaveClick: function () {
      this.$log.info('onSaveClick')
      this.goSave()
    },
    onReload: function () {
    },
    onInfoClick: function (event) {
      let message = [{text: ''}]
      if (event.target.className.includes('tlsVersion')) {
        message = [{text: this.$t('systemHttps.tlsVersionInfo')}]
      } else if (event.target.className.includes('httpsOnly')) {
        message = [{text: this.$t('systemHttps.httpsOnlyInfo')}]
      }
      this.$store.commit('updateInfoTips', !this.showInfoTips)
      if (this.showInfoTips) {
        this.$store.commit('updateInfoData', {
          message: message,
          event: event
        })
      }
    },
    getErrorMsg: function (type) {
      let message = ''
      if (this.isValidateInvalid(type)) {
        message = this.errors.first(type)
      }
      return message
    },
    isValidateInvalid: function (type) {
      return this.errors.has(type)
    },
    onBlur: function () {
      this.$validator.validateAll()
    },
    onOpen () {
      // this.openModal(this.modalname)
      // this.isModalOpen = true
      // this.$modal.show(this.modalname)
    },
    onClose () {
      // this.closeModal(this.modalname)
      // this.isModalOpen = false
      // this.$modal.hide(this.modalname)
    },
    ...mapMutations([ 'openModal', 'closeModal' ]),
    ...mapActions([
      'getSystemHttps', 'setSystemHttps'
    ])
  },
  computed: {
    // ...mapGetters(['getTopModalName']),
    ...mapState({
      showInfoTips: state => state.app.showInfoTips,
      showFullLoading: state => state.module.showFullLoading,
      isDataChanged: state => state.app.isDataChanged,
      currentUser: state => state.module.currentUser,
      intervalTime: state => state.app.intervalTime
    })
  }
}
</script>
<style lang="scss" scoped>

.syshttps {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    padding: 20px 10px 10px 10px;
    .formRow {
      .formlabel {
        .checkbox-wrapper {
          display: inline-block;
        }
      }
      .forminput {
        margin: 0px 0px 0px 30px;
        >.table-row {
          .tls {
            margin-top: 16px;
            .title {
              font-size: 14px;
              line-height: 16px;
              color: #000000;
              width: auto;
              display: inline-block;
              font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
            }
            .select-wrapper {
              display: inline-block;
              vertical-align: middle;
              margin-left: 2px;
              /deep/ .q-select {
                width: auto;
                min-width: 132px;
                height: 30px;
                vertical-align: top;
                border: 1px solid #848484;
                .dropdown-menu {
                  min-width: 132px;
                  .scrollbar-body {
                    .scroll-content > li {
                      > a {
                        font-size: 14px !important;
                        font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
                        color: #4C4C4C;
                      }
                    }
                  }
                }
                .display-label {
                  font-size: 14px !important;
                  line-height: 28px !important;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
                  color: #4C4C4C;
                }
                .triangle {
                  color: #4C4C4C;
                }
              }
            }
            .info {
              margin-top: 10px;
              line-height: 18px;
              font-size: 13px;
              color: #195A87;
              width: auto;
              font-family: 'PingFang TC', 'Microsoft JhengHei' !important;
            }
          }
          .httpsPort {
            margin-top: 20px;
            .title {
              font-size: 14px;
              line-height: 16px;
              color: #000000;
              width: auto;
              display: inline-block;
              font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
            }
            .input-wrapper {
              display: inline-block;
              vertical-align: middle;
              margin-left: 2px;
              input {
                border: 1px solid #848484;
                border-radius: 4px;
                font-size: 14px;
                height: 30px;
                width: 140px;
                color: #4c4c4c;
                line-height: 30px;
                font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              }
            }
            .errorMessage {
              display: inline-block;
              vertical-align: middle;
            }
          }
          .httpsOnly {
            margin-top: 20px;
            .checkbox-wrapper {
                display: inline-block;
            }
            /deep/ .q-checkbox-label {
              &.disabled .text{
                cursor: default;
                color: #AEAEAE;
              }
            }
            .info {
              margin-top: 10px;
              line-height: 18px;
              font-size: 13px;
              color: #195A87;
              width: auto;
              font-family: 'PingFang TC', 'Microsoft JhengHei' !important;
            }
          }
        }
        &.disabled, &.disabled >.table-row .title {
          color: #AEAEAE;
        }
      }
      /deep/ .q-checkbox-label {
        width: auto;
        height: auto;
        cursor: pointer;
        .icon {
          display: inline-block;
          vertical-align: middle;
          color: #4C4C4C;
        }
        .text {
          display: inline-block;
          vertical-align: middle;
          margin-left: 0px;
          color: #000000;
          font-size: 14px;
          line-height: 16px;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
      }
    }
    .content-body-footer {
      top: calc(100% - 50px) !important;
      .q-button {
        min-width: 80px;
        font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
      }
    }
    .scrollbar-body {
      height: calc(100% - 40px);
      padding: 0px 10px;
    }
  }
  .alert .q-v--modal {
    height: auto;
    .modal-footer {
      justify-content: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemHttps.vue